{
  "longPressMessage": "長押ししてプレビューを開く"
}
